import React from 'react';

import {LoadingSpinner} from '@newsela/angelou';
import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';


const LazyVideoContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "StandaloneVideo" */
    './components/StandaloneVideo'
  ),
  delay: 1000,
  // eslint-disable-next-line
  loading: (props) => (props.pastDelay ? <LoadingSpinner /> : null)
});

const VideoRoute = (
  <Route
    path="/videos/:slug"
    component={LazyVideoContainer}
  />
);

export default VideoRoute;
